export default __webpack_public_path__ + "static/brokers-image-1-4c9d1f8c91bfa453a90c57beb39dc6e6.png";